var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RadioButton as StyledRadioButton } from './style';
import { Icon } from '../Button';
var RadioButton = function (props) {
    var value = props.value, icon = props.icon, active = props.active;
    return (_jsxs(StyledRadioButton, __assign({ type: "button", active: active, iconLeft: Boolean(value && icon), iconOnly: Boolean(!value && icon) }, props, { children: [icon && _jsx(Icon, { as: icon }), value && value] })));
};
export { RadioButtonGroup } from './style';
export default RadioButton;
//# sourceMappingURL=index.js.map